import instObj from '@/backend/axios-instances'

const resource = "/ticketing/contact"
const instance = instObj.baseInstance

export default {
  get(contactId) {
    return instance.get(`${resource}/${contactId}`);
  },
  delete(contactId) {
    return instance.delete(`${resource}/${contactId}`);
  },
  put(contactId, data) {
    return instance.put(`${resource}/${contactId}`, data);
  }
}
